import type { FaireProductEntity } from "../../entity_types/product";

export const casa_bosques_3: FaireProductEntity = {
  token: "casa-bosques-3",
  type: "product",
  name: "Pink Peppercorn",
  brandName: "Casa Bosques",
  imageUrl:
    "https://cdn.faire.com/fastly/caf7209f6d2ccd2a0788d0e7d01c881a2ef681b83dade8fbc52a58c43b34b126.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 8.5,
  msrpDollars: 14,
  freeShipping: true,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
